import { Countries, Country_code } from '@/core/types';


export type State = {
  countries: Array<Countries>;
  uae_id: number | null;
  countryCode: Array<Country_code>;
  company_info:any;
}

export const state: State = {
  countries: [] as Array<Countries>,
  uae_id:  99,
  countryCode: [] as Array<Country_code>,
  company_info:{
    whatsapp_url:'https://wa.me/96171396654',
    toll_free_number: '81 444 360',
    toll_free_number_tel: 'tel:81444360',
    landline_number: '05 459 475',
    landline_number_tel: 'tel:05459475',
    email:'info@compare360.com',
    address:"Street 611, Brasilia, Baabda, Lebanon",
    disclaimers: 'Compare360 is the owner of the brand name “Compare360.com". Insurance is provided by Chedid Insurance Brokers SAL.'
  }
};